// extracted by mini-css-extract-plugin
export default {"wrapper":"Prompt_wrapper__YD9+a","submitPass":"Prompt_submitPass__Wka7T","manCrying":"Prompt_manCrying__FIjZm"};